

export function saveLa(taskId:number, inputId:number, input:HTMLElement){

    const labels = $(input).find(".label-item");
    const givenAnswers = [];

    labels.each((ind, obj) => {

        const input = $(obj).find("input");
        const answer = input.val();

        givenAnswers.push({answer: answer});

    });

    return {answer: givenAnswers};

}
